import * as React from 'react';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Typography from '@mui/material/Typography';
import { Grid } from '@mui/material';
import logo from './../../assets/images/logo.svg';


export default function SuccessDialog(props) {
    return (
        <React.Fragment>

                 
            <Grid container spacing={3} flexDirection="column" justifyContent="center" alignItems="center" sx={{ mt: 15 }}>
                        <img src={logo} alt="Logo" style={{ width: '200px', height: 'auto' }} />
                <DialogTitle sx={{ textAlign: "center" }} id="alert-dialog-title" mt={5}>
                    {/* {"Thank you for registering!"} */}
                    <Typography variant="h4" component="h4">
                    Thank you for applying to ZUUG as a Shadchan
                    </Typography>

                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description" mt={2} mb={20}>
                        <Typography variant="h6" component="h6">
                        We are processing your application.
                        </Typography>
                        <Typography variant="h6" component="h6">
                        Please look out for an acceptance email from ZUUG containing your login password.
                        </Typography>

                    </DialogContentText>
                </DialogContent>
            </Grid>
        </React.Fragment>
    );
}